import React from "react";
import { Button, Icon } from "antd";

export const columns = exportData => [
  {
    title: "kpi id",
    dataIndex: "id",
    key: "id",
    render: id => {
      return <span>{id}</span>;
    }
  },
  {
    title: "kpi label",
    dataIndex: "long_label",
    key: "long_label",
    render: label => {
      return <span>{label}</span>;
    }
  },
  {
    title: "kpi description",
    dataIndex: "description",
    key: "description",
    render: description => {
      return <span>{description}</span>;
    }
  },
  {
    title: "export",
    dataIndex: "_id",
    key: "_id",
    render: (_, kpi) => {
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", float: "right" }}>
          <Button style={{ color: "white" }} type="primary" size={"default"} onClick={() => exportData(kpi, "full")}>
            <Icon type="download" /> Données complètes
          </Button>

          <Button style={{ color: "white" }} type="primary" size={"default"} onClick={() => exportData(kpi, "raw")}>
            <Icon type="download" /> Données brutes
          </Button>
        </div>
      );
    }
  }
];



// WEBPACK FOOTER //
// src/modules/downloadstats/downloadstats.utils.js